import React from "react";
import { graphql } from "gatsby";
import Story from "../components/story";
import SEO from "../components/seo";
import Layout from "../containers/layout";

export const query = graphql`
  query ArticleEsReadQuery($id: String!) {
    story: sanityEsStories(id: { eq: $id }) {
      id
      subtitle
      publishedAt
      entity
      mainImage {
        crop {
          _key
          _type
          top
          bottom
          left
          right
        }
        hotspot {
          _key
          _type
          x
          y
          height
          width
        }
        asset {
          _id
        }
        alt
      }
      title
      slug {
        current
      }
      _rawBody
      writer {
        name
        image {
          crop {
            left
            right
            _key
            _type
            bottom
            top
          }
          hotspot {
            _key
            _type
            x
            y
            height
            width
          }
          asset {
            _id
          }
        }
      }
    }
  }
`;
const esStoryBuilder = props => {
  const { data, pageContext } = props;
  const story = data && data.story;
  const currentSlug = "https://crema.cm/es/recursos/historias/"+story.entity+"/"+story.slug.current+"/"
  const language = pageContext.language;
  const canonical = [
    {
      rel: "canonical",
      href: currentSlug
    },
    {
      rel: "alternate",
      href: currentSlug,
      hrefLang: 'es'
    },
    {
      rel: "alternate",
      href: currentSlug,
      hrefLang: 'x-default'
    }
  ];
  const ogurl = currentSlug;
  // (story.mainImage.asset && imageUrlFor(buildImageObj(story.mainImage)).width(600).height(Math.floor((9 / 16) * 600)).fit("crop").url()) || 
  const ogimg = "https://crema.cm/assets/img/640blurple.png";
  const ogentity = (story.entity === 'compania' && 'Compañia') || (story.entity === 'tips' && 'Tips') || (story.entity === 'tutoriales' && 'Tutoriales') || (story.entity === 'comunidad' && 'Comunidad');
  const keywords = ["Crema", "Articulo", "Blog", "Historias", "Freelancers", "Profesionistas Independientes"]
  return (
    <Layout language={language} topMenu="historias">
      <SEO lang={language} title={story.title +" - Crema Blog"} description={story.subtitle} canonical={canonical} keywords={keywords} ogurl={ogurl} ogimg={ogimg} index="noindex, nofollow"/>
      <Story language={language} {...story} />
    </Layout>
  );
};
export default esStoryBuilder;